<template>
    <div class="home-info">
        <div class="home-info-box">
            <p class="home-info-title">
                包车活动资讯一手掌握
            </p>

            <ul class="home-info-ul">
                <li class="home-info-li"
                    :class="liNumSign == index ? 'home-info-li-ac' : ''"
                    v-for="(item,index) in liListSign"
                    :key="index"
                    @click="liClickSign(index)"
                >
                    {{ item.text }}
                </li>
            </ul>

            <div class="home-info-area">
                <div class="home-info-left"
                     v-for="(item, index) in signList"
                     :key="index"
                     @click="toSignDetail(item.id,item.cate_id)"
                >
                    <div class="info-left-img">
                        <img :src="item.img" alt="">
                    </div>
                    <p class="info-left-title">{{ item.title }}</p>
                    <p class="info-left-content">{{ item.synopsis }}</p>
                    <div class="info-left-bot">
                        <p @click="toSignDetail(item.id,item.cate_id)">阅读更多</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "homeModel",
        props: {
            signList: {
                type: Array,
                default: [],
            }
        },
        data() {
            return {
                liNumSign: 0,
                liListSign: [
                    {
                        text: '旅游包车'
                    },
                    {
                        text: '大巴包车'
                    },
                    {
                        text: '更多资讯 >'
                    }
                ],
                /*signList: [
                    {
                        carImg: require('@/assets/images/index/carImg.png'),
                        carName: '丰田考斯特',
                        carSeat: 7,
                    },
                    {
                        carImg: require('@/assets/images/index/carImg.png'),
                        carName: '丰田考斯特',
                        carSeat: 8,
                    },
                    {
                        carImg: require('@/assets/images/index/carImg.png'),
                        carName: '丰田考斯特',
                        carSeat: 9,
                    },
                    {
                        carImg: require('@/assets/images/index/carImg.png'),
                        carName: '丰田考斯特',
                        carSeat: 10,
                    },
                    {
                        carImg: require('@/assets/images/index/carImg.png'),
                        carName: '丰田考斯特',
                        carSeat: 11,
                    }
                ]*/
            }
        },
        methods: {
            liClickSign(num) {
                this.liNumSign = num;
                this.$emit('signTypeChange',this.liNumSign);
            },
            toSignDetail(id,cate_id){
                // var that = this;
                // that.$router.push({path: "/informationDetails", query: {id: id, cate_id: cate_id}});

                var cidgid=id+"_"+cate_id;
                // console.log(cidgid)
                this.$router.push({name:"InformationDetails",params:{cidgid:cidgid+".html"}});
            }
        }
    }
</script>

<style scoped>
    .home-info {
        width: 100%;
        min-width: 1200px;
        margin-top: 30px;
    }

    .home-info-box {
        width: 1200px;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        padding-top: 70px;
    }

    .home-info-title {
        width: 500px;
        height: 38px;
        line-height: 38px;
        text-align: center;
        color: #333;
        font-size: 32px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        margin: 0 auto;
    }

    .home-info-ul {
        width: 600px;
        height: 24px;
        line-height: 24px;
        margin: 20px auto 0;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
    }

    .home-info-li {
        width: 120px;
        height: 20px;
        line-height: 20px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666;
        text-align: center;
        border-left: 1px solid #666;
        cursor: pointer;
    }

    .home-info-li:nth-child(1) {
        border-left: none;
    }

    .home-info-li-ac {
        color: #FA592A;
    }

    .home-info-area {
        width: 1200px;
        margin: 44px auto 0;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
    }

    .home-info-left {
        width: 283px;
        height: 368px;
        border: 1px solid #E7E7E7;
        display: flex;
        flex-direction: column;
        margin-right: 19px;
        margin-bottom: 25px;
        cursor: pointer;
    }

    .home-info-left:nth-child(4n) {
        margin-right: 0;
    }

    .info-left-img {
        width: 283px;
        height: 184px;
    }

    .info-left-img img {
        width: 100%;
        height: 100%;
    }

    .info-left-title {
        width: 264px;
        margin: 15px auto 0;
        line-height: 30px;
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333333;
    }

    .info-left-content {
        width: 264px;
        height: 46px;
        line-height: 23px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: normal;
        margin: 5px auto 0;
    }

    .info-left-bot {
        width: 264px;
        margin: 10px auto 0;
    }

    .info-left-bot p {
        width: 70px;
        height: 24px;
        line-height: 24px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        text-decoration: underline;
        color: #333333;
        cursor: pointer;
    }

</style>



// WEBPACK FOOTER //
// src/pages/home/components/homeInfo.vue